import React from "react";

function SerProducts() {
  const services = [
    {
      title: "Architecture Design",
      image: "/images/p1.jpeg",
    },
    {
      title: "Interior Designing",
      image: "/images/p2.jpeg",
    },
    {
      title: "Construction",
      image: "/images/p3.jpeg",
    },
    {
      title: "Project Management",
      image: "/images/p4.jpeg",
    },
  ];

  return (
    <section className="py-16 px-5 bg-gray-100 text-center">
      <div className="max-w-7xl mx-auto">
        
        {/* Heading */}
        <h1 className="text-3xl md:text-4xl font-semibold mb-4">
          Complete Architecture & Interior Solutions in Varanasi
        </h1>

        <p className="text-gray-600 text-lg mb-12 max-w-3xl mx-auto">
          From Concept to Completion — End-to-End Design, Build & Interior
          Services crafted to bring elegance, functionality, and comfort to
          your space.
        </p>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 cursor-pointer"
            >
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-72 object-cover"
              />

              <div className="bg-black text-white py-4 text-lg font-medium">
                {service.title}
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}

export default SerProducts;